import local from '@/local'
import { Logger } from 'shared'

export default new Logger(local.domain)
